import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-three-sixty-dashboard-popups',
  templateUrl: './three-sixty-dashboard-popups.component.html',
  styleUrls: ['./three-sixty-dashboard-popups.component.scss'],
})
export class ThreeSixtyDashboardPopupsComponent implements OnInit {
  isToggleChecked: any = false;
  loggedInUserCompanyID: any;
  selectedYear: any;
  isComplete: boolean = false;
  counterListData: any = [];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ThreeSixtyDashboardPopupsComponent>, private encryptionService: EncryptionService, public router: Router, private activatedroute: ActivatedRoute,
    public dialog: MatDialog, public sharedService: SharedService,
    private loader: LoaderService,
    private httpService: HttpService, private config: Config, private fb: FormBuilder,
    private datePipe: DatePipe) { }

  ngOnInit() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.selectedYear = this.data.selectedYear;
    this.get360CounterPopUp();
  }
  get360CounterPopUp() {
    const year = this.selectedYear?.split('-');
    const request = {
      "band": null,
      "companyId": this.loggedInUserCompanyID,
      "competencyId": [],
      "fromYear": year[0],
      "isComplete": this.isToggleChecked,
      "isTopAnalysis": false,
      "reviewId": null,
      "toYear": year[1],
      "userId": null
    }
    this.httpService.callPostService(this.config.get360CounterPopUp, request).subscribe((data: any) => {
      this.counterListData = data?.data;
    })
  }
  isDownload: boolean = true;
  onClickDownloadScoresOfSurveys(id: any) {
    const flattenedData: any[] = [];
    this.counterListData.forEach((ele: any) => {
      flattenedData.push({
        "Start Date": this.datePipe.transform(ele.startDate, "dd/MM/yyyy"),
        "End Date": this.datePipe.transform(ele.endDate, "dd/MM/yyyy"),
        "Name of 360 Review": ele.reviewName,
        "No. of self": ele.noOfSelf,
        "No. of peers": ele.noOfPeer,
        "No. of subordinates": ele.noOfSubordinate,
        "No. of superior": ele.noOfSuperior,
        "No. of internal customer": ele.noOfInternalCustomer,
        "No. of external customer": ele.noOfExternalCustomer,
        "Total Employee": ele.noOfTotalEmployee,
        "Completed": ele.noOfCompleted,
        "Incompleted": ele.noOfIncompleted,
      });
    });
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
    const fileName = '360_degree_created_by_HR' + formattedDate + '.xlsx';
    saveAs(data, fileName);
    this.isDownload = true;
    this.loader.dismissLoader()
  }
}
